import * as types from './types';

const availabilityRequirementScheduleUpdated = (id, schedule, mergeMode) => ({
  type: types.AVAILABILITY_REQUIREMENT_SCHEDULE_UPDATED,
  timestamp: Date.now(),
  mergeMode,
  payload: {
    id,
    schedule
  }
});

// For batching multiple updates. Improves performance because there is only 1
// state change. It returns a set of actions of type
// AVAILABILITY_REQUIREMENT_SCHEDULE_UPDATED
const availabilityRequirementScheduleBatchUpdate = (schedules, mergeMode) => ({
  type: types.AVAILABILITY_REQUIREMENT_SCHEDULE_BATCH_UPDATE,
  timestamp: Date.now(),
  mergeMode,
  payload: {
    actions: schedules.map(schedule =>
      availabilityRequirementScheduleUpdated(schedule.availability_requirement.id, schedule, mergeMode)
    )
  }
});

const fetchAvailabilityRequirementScheduleStart = () => ({
  type: types.START
});

const fetchAvailabilityRequirementScheduleSuccess = () => ({
  type: types.SUCCESS
});

export {
  availabilityRequirementScheduleUpdated,
  availabilityRequirementScheduleBatchUpdate,
  fetchAvailabilityRequirementScheduleStart,
  fetchAvailabilityRequirementScheduleSuccess
};
